import type { IconProps } from "@braze/beacon-core";

/**
 * Icon shared by the Operator tools that drive a dropdown. The dropdown-control glyph reads as
 * "a dropdown was used" in the tool call list, where a bare caret reads as an expand affordance
 * and invites a click the tool call row does not answer.
 */
export const selectToolIconName: IconProps["name"] = ["far", "list-dropdown"];
